
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/openai-ui",
      function () {
        return require("private-next-pages/openai-ui.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/openai-ui"])
      });
    }
  